var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8337 14C13.8337 13.0696 13.8337 12.6044 13.7188 12.2259C13.4603 11.3736 12.7934 10.7067 11.9411 10.4482C11.5626 10.3333 11.0974 10.3333 10.167 10.3333H6.83366C5.90328 10.3333 5.43809 10.3333 5.05956 10.4482C4.2073 10.7067 3.54035 11.3736 3.28182 12.2259C3.16699 12.6044 3.16699 13.0696 3.16699 14M11.5003 5C11.5003 6.65685 10.1572 8 8.50033 8C6.84347 8 5.50033 6.65685 5.50033 5C5.50033 3.34315 6.84347 2 8.50033 2C10.1572 2 11.5003 3.34315 11.5003 5Z",
    stroke: "#A4A7AE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.b7d0898a780f674b1ffe44f13d5acb76.svg";
export { ForwardRef as ReactComponent };